<template>
  <v-container fluid class="pa-4 pa-sm-6 pa-md-8">
    <v-dialog v-model="dialog" max-width="950px" max-height="800px">
      <v-card class="modal-card" >
        <v-btn
  fab
  color="primary"
  class="help-button custom-small-btn"
  @click="showHelp"
  aria-label="Abrir guia de ajuda"
>
  <v-icon size="16">mdi-help-circle</v-icon>
</v-btn>
        <v-card-text>
          <v-form class="form-inputs" ref="form" v-model="isFormValid">
            <v-row>
              <v-col cols="12" sm="5" class="image-container">
                <div class="image-upload-placeholder">
                  <label for="file-upload" class="image-label">
                    <v-icon size="80" color="grey lighten-1" v-if="!novoCapitulo.imagem">
                      mdi-image
                    </v-icon>
                    <img v-else :src="novoCapitulo.imagem" alt="Pré-visualização da capa" class="image-preview" />
                    <div class="image-text" v-if="!novoCapitulo.imagem">Clique para adicionar uma imagem (PNG, JPG, WebP, A5, até 6MB)</div>
                  </label>
                  <input
                    type="file"
                    id="file-upload"
                    ref="fileInput"
                    class="file-input"
                    accept="image/png, image/jpeg, image/webp"
                    aria-label="Upload da imagem do capítulo"
                    @change="onImageSelected"
                  />
                  <div v-if="!novoCapitulo.imagem && showErrors" class="error-message">A imagem é obrigatória.</div>
                </div>
                <div v-if="novoCapitulo.imagem" class="image-preview-container">
                  <v-btn small color="primary" @click="$refs.fileInput.click()">Trocar Imagem</v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="7">
                <v-text-field
                  v-model="novoCapitulo.nome"
                  label="Nome do Capítulo"
                  placeholder="Ex: Capítulo 1: O Início"
                  outlined
                  dense
                  class="custom-input"
                  :rules="[rules.required]"
                  required
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Insira o título do capítulo.</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-textarea
                  v-model="novoCapitulo.descricao"
                  label="Descrição do Capítulo"
                  placeholder="Ex: Uma introdução ao mundo da história..."
                  outlined
                  dense
                  rows="4"
                  class="custom-input"
                  :rules="[rules.required]"
                  required
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Descreva brevemente o conteúdo do capítulo.</span>
                    </v-tooltip>
                  </template>
                </v-textarea>
                <v-divider class="my-4"></v-divider>
                <div class="d-flex align-center">
                  <h4 class="mb-0">Agendamento</h4>
                  <v-spacer></v-spacer>
                  <v-checkbox
                    v-model="novoCapitulo.agendar"
                    label="Agendar publicação"
                    dense
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                </div>
                <v-row v-if="novoCapitulo.agendar">
                  <v-col cols="12" sm="6">
                    <scheduled-date-field
                      v-model="novoCapitulo.scheduled_date"
                      label="Data"
                    ></scheduled-date-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <scheduled-time-field-24h
                      v-model="novoCapitulo.scheduled_time"
                      label="Hora"
                    ></scheduled-time-field-24h>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="actions-container">
          <v-btn color="red darken-1" text @click="closeModal" block>
            Cancelar
          </v-btn>
          <v-btn class="zinnes-primary-btn" dark @click="salvarCapitulo" block>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
      {{ snackbar.message }}
    </v-snackbar>

    <v-dialog v-model="helpDialog" max-width="500px">
      <v-card>
        <v-card-title>Como preencher o formulário</v-card-title>
        <v-card-text>
          <p><strong>Nome do Capítulo:</strong> Insira o título do capítulo, como "Capítulo 1: O Início".</p>
          <p><strong>Descrição do Capítulo:</strong> Adicione uma breve descrição do conteúdo do capítulo.</p>
          <p><strong>Imagem:</strong> Clique para fazer upload de uma imagem representativa (PNG ou JPG, formato A5).</p>
          <p><strong>Agendamento:</strong> Marque "Agendar publicação" para escolher a data e a hora em que o capítulo será publicado automaticamente.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="helpDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { publiChapter, getchapters } from '../server/workService.js';
import { buildScheduledAt } from '@/utils/scheduling';
import ScheduledDateField from '@/components/ScheduledDateField.vue';
import ScheduledTimeField24h from '@/components/ScheduledTimeField24h.vue';

export default {
  name: "AddCapitulo",
  components: { ScheduledDateField, ScheduledTimeField24h },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    idObra: {
      type: String,
      required: true
    },
    obras: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: this.value,
      novoCapitulo: {
        nome: '',
        descricao: '',
        imagem: null,
        file: null,
        agendar: false,
        scheduled_date: '',
        scheduled_time: '',
        scheduled_at: null
      },
      snackbar: {
        show: false,
        message: '',
        color: '',
        timeout: 2500,
      },
      isFormValid: true,
      showErrors: false,
      rules: {
        required: value => !!value || 'Este campo é obrigatório'
      },
      newObras: [],
      helpDialog: false,
    };
  },
  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newValue) {
      this.$emit('input', newValue);
    },
    newObras(newValue) {
      this.$emit('updateNewChapter', newValue);
    }
  },
  methods: {
    closeModal() {
      this.dialog = false;
      this.novoCapitulo = {
        nome: '',
        descricao: '',
        imagem: null,
        file: null,
        agendar: false,
        scheduled_date: '',
        scheduled_time: '',
        scheduled_at: null
      };
      this.showErrors = false;
      this.$refs.form.resetValidation();
    },
    onImageSelected(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith('image/')) {
          this.showSnackbar('Por favor, selecione um arquivo de imagem válido (PNG ou JPG).', 'error');
          return;
        }
        if (file.size > 6 * 1024 * 1024) {
          this.showSnackbar('A imagem deve ter no máximo 6MB.', 'error');
          return;
        }
        this.novoCapitulo.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.novoCapitulo.imagem = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.showSnackbar('Nenhum arquivo selecionado.', 'error');
      }
    },
    async salvarCapitulo() {
      this.showErrors = !this.isFormValid || !this.novoCapitulo.imagem;

      if (!this.isFormValid) {
        this.showSnackbar('O formulário contém erros. Verifique os campos obrigatórios.', 'error');
        return;
      }

      if (!this.novoCapitulo.imagem) {
        this.showSnackbar('É necessário adicionar uma imagem para o capítulo.', 'error');
        return;
      }

      if (this.novoCapitulo.agendar && (!this.novoCapitulo.scheduled_date || !this.novoCapitulo.scheduled_time)) {
        this.showSnackbar('Informe a data e a hora do agendamento.', 'error');
        return;
      }

      if (this.novoCapitulo.agendar) {
        const scheduled = new Date(`${this.novoCapitulo.scheduled_date}T${this.novoCapitulo.scheduled_time}:00`);
        if (Number.isNaN(scheduled.getTime())) {
          this.showSnackbar('Data de agendamento inválida.', 'error');
          return;
        }
      }

      this.novoCapitulo.scheduled_at = this.novoCapitulo.agendar
        ? buildScheduledAt(this.novoCapitulo.scheduled_date, this.novoCapitulo.scheduled_time)
        : null;

      try {
        await publiChapter(this.idObra, this.novoCapitulo);
        const chapters = await getchapters(this.idObra);
        this.newObras = chapters.chapters;
        this.showSnackbar('Capítulo adicionado com sucesso!', 'success');
        this.closeModal();
      } catch (error) {
        this.showSnackbar(`Erro ao adicionar capítulo: ${error.message}`, 'error');
      }
    },
    showSnackbar(message, type) {
      this.snackbar.message = message;
      this.snackbar.color = type === 'success' ? 'green' : 'red';
      this.snackbar.show = true;
    },
    showHelp() {
      this.helpDialog = true;
    }
  }
};
</script>

<style scoped>

.custom-small-btn {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
}
.custom-small-btn .v-icon {
  font-size: 16px !important;
}
@media (max-width: 600px) {
  .image-preview {
    max-width: 100%;
    height: auto;
  }
  .image-text {
    font-size: 12px;
  }
  .custom-input {
    font-size: 14px;
  }
  .modal-card {
    height: auto !important;
    max-height: calc(90vh - 56px);
    overflow-y: auto;
  }
  .image-upload-placeholder {
    height: 200px !important;
    width: 90% !important;
  }
}

@media (max-width: 400px) {
  .image-preview {
    max-width: 100%;
    height: auto;
  }
  .image-text {
    font-size: 16px;
  }
  .image-upload-placeholder {
    background-color: #4d4d4d;
    border: 2px dashed #b0b0b0;
    width: 60% !important;
    height: 250px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #b0b0b0;
  }
}

.modal-card {

  color: #fff;
  height: auto !important;
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  position: relative;
}

.image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image-upload-placeholder {
  background-color: #4d4d4d;
  border: 2px dashed #b0b0b0;
  width: 85%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #b0b0b0;
  cursor: pointer;
}

.image-preview-container {
  text-align: center;
  margin-top: 10px;
}

.image-preview {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
}

.image-text {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}

.image-label {
  cursor: pointer;
}

.file-input {
  display: none;
}

.error-message {
  color: #ff5252;
  font-size: 12px;
  text-align: center;
  margin-top: 8px;
}

.actions-container {
  display: flex;
  align-items: center;
  justify-content: end;
}

.custom-input {
  margin-bottom: 10px;
}

.help-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
